<template>
  <div id="app">
    <div hidden style="width: 0; height: 0">{{ getbarIndex }}</div>

    <router-view v-cloak id="view" :class="{ bar: hasBar }" key="123213" />

    <van-tabbar
      safe-area-inset-bottom
      v-model="active"
      v-if="hasBar"
      :border="false"
      active-color="#4899ff"
    >
      <van-tabbar-item
        v-touch:tap="tapItem(item, index)"
        class="tabbar-item zx-tabbar-item"
        :class="active === item.id ? 'tabbar-item-active' : ''"
        v-for="(item, index) in tabbarList"
        :key="index"
      >
        <!-- <i class="iconfont icon-size" :class="item.iconName"></i> -->
        <van-image
          class="tabbar-item-image"
          lazy-load
          fit="contain"
          :src="item.image"
        />
        <div class="name g-b-500">{{ item.name }}</div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from "vant";
import { addNumberOfVisits } from "@js/url.js";
export default {
  provide() {
    return {
      reload: () => {
        this.$router.go(0);
      },
    };
  },
  data() {
    return {
      active: 0,
      tabbarList: [
        {
          id: 0,
          name: "首页",
          iconName: "iconshouye2",
          image: require("@image/home/56.png"),
          routerName: "Home",
        },
        {
          id: 1,
          name: "个人中心",
          iconName: "icongerenzhongxin",
          image: require("@image/home/22.png"),
          // routerName: 'About',
          routerName: "personalCenter",
        },
      ],
    };
  },
  created() {
    let localURL = localStorage.getItem("redirectUri");
    let second = localStorage.getItem("secondIn");
    console.log("跳轉", localURL);
    this.$router.replace({ path: localURL });
    if (localURL && second) {
      localStorage.removeItem("redirectUri");
      localStorage.removeItem("secondIn");
    }
  },
  mounted() {
    this.addNumberOfVisitsFc();
  },
  methods: {
    tapItem(item, index) {
      return () => {
        if (String(item.id)) {
          this.active = index;
        } else {
          this.active = 99;
          this.$store.commit("setBarActive");
        }
        this.$router.push({ name: item.routerName }).catch((err) => {
          err;
        });
      };
    },
    addNumberOfVisitsFc() {
      addNumberOfVisits(window.location.href);
    },
  },
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
  computed: {
    hasBar() {
      return this.$store.state.hasTabbar;
    },
    getbarIndex() {
      let number = this.$store.state.barActive;
      this.active = number;
      return this.$store.state.barActive;
    },
  },
  watch: {
    $route: "addNumberOfVisitsFc",
  },
};
</script>

<style lang="less" scoped>
#view {
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background-color: #f0f1f4;
  transition: height 0.5s ease;
  &.bar {
    height: ~"calc(100% - 50px - constant(safe-area-inset-bottom))";
    height: ~"calc(100% - 50px - env(safe-area-inset-bottom))";
  }
}
.transition-box {
  height: 100%;
}
.icon {
  text-align: center;
  margin-bottom: 5px;
}
.tabbar-item {
  z-index: 1;
  position: relative;
  text-align: center;
  width: 100%;
  .icon-size {
    overflow: hidden;
    &::before {
      font-size: 20px;
    }
  }
  .tabbar-item-image {
    margin-top: 3px;
    width: 20px;
    height: 20px;
  }
  .name {
    font-weight: 500;
    margin-top: 5px;
    font-size: 10px !important;
  }
}
.tabbar-item-active {
  &::before {
    content: "";
    z-index: -1;
    position: absolute;
    transform: translateX(-50%);
    top: 22px;
    left: 50%;
    width: 89px;
    background: rgba(226, 243, 255, 1);
    border-radius: 50%;
    height: 100px;
  }
}
</style>
